/**
 * @generated SignedSource<<3a51137d8d4de43dbdf6e99e6df2ee4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedRecentlyViewedItems_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly " $fragmentType": "HpSharedRecentlyViewedItems_componentModule";
};
export type HpSharedRecentlyViewedItems_componentModule$key = {
  readonly " $data"?: HpSharedRecentlyViewedItems_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedRecentlyViewedItems_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedRecentlyViewedItems_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    }
  ],
  "type": "RecentlyViewedModule",
  "abstractKey": null
};

(node as any).hash = "84d16195ac4b782b333f7b478adbd122";

export default node;
